import Objects from '@/classes/procedure_executions/Objects'
import Customer from '@/classes/customers/Customer'
import Informations from '@/classes/procedure_executions/Informations'

export default class PublicProcedureExecution {
  constructor ({ id = null, objects = {}, informations = {}, customer = {}, procedure_id = null, user_id = null, created_at = null } = {}) {
    this.id = id
    this.objects = new Objects(objects)
    this.informations = new Informations(informations)
    this.customer = new Customer(customer)
    this.procedure_id = procedure_id
    this.user_id = user_id
    this.created_at = created_at
  }

  get transaction () {
    return this.objects.transaction
  }
}
